/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_TASKS, GET_TASKS } from 'src/actions/taskActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const taskReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_TASKS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_TASKS: {
      const { tasks, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = tasks;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default taskReducer;
